import { Component } from 'react';
import { raygunSendError } from '../helpers/RaygunUtility';

export interface ErrorBoundaryProps {
  children: React.ReactNode;
  errorContent?: React.ReactNode;
  sendToRaygun?: boolean;
}

export interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.error(error, info);

    if (this.props.sendToRaygun) {
      raygunSendError(error);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.errorContent) {
        return this.props.errorContent;
      }
      return null;
    }
    return this.props.children;
  }
}
